import { render, staticRenderFns } from "./ManageOptionAssets.vue?vue&type=template&id=2897a30c&scoped=true&"
import script from "./ManageOptionAssets.vue?vue&type=script&lang=js&"
export * from "./ManageOptionAssets.vue?vue&type=script&lang=js&"
import style0 from "./ManageOptionAssets.vue?vue&type=style&index=0&id=2897a30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2897a30c",
  null
  
)

export default component.exports